import { PayloadAction } from "@reduxjs/toolkit";
import { User, UserState } from "types/User";

const setUsers = (state: UserState, action: PayloadAction<User[]>): void => {
  state.users = action.payload;
};

const setFilterRoleMembers = (
  state: UserState,
  action: PayloadAction<User[]>
): void => {
  state.filterRoleMembers = action.payload;
};

const setNonFilterRoleMembers = (
  state: UserState,
  action: PayloadAction<User[]>
): void => {
  state.nonFilterRoleMembers = action.payload;
};

const reducers = {
  setUsers,
  setFilterRoleMembers,
  setNonFilterRoleMembers,
};

export default reducers;
